import request from '@/tools/request';

// 获得 项目详情
export const getProjectInfoById = {
  root: false,
  handler: async ({ state, commit }, { query, projectItem }) => {
    // TODO：联调
    const {
      data: { data: detail }
    } = await request.post(
      '/rest/cso/saas/taskRecordAndSummaryDoc/queryCsoProjectNew',
      { projectId: query.projectId, type: projectItem.type }
    );

    // 设置项目 详情
    commit('SET_PROJECT_DETAIL', {
      projectDetail: detail
    });
  }
};
// 获得 汇总
export const getProjectSummaryById = {
  root: false,
  handler: async ({ state, commit }, { query }) => {
    const {
      data: { data }
    } = await request.post('/rest/cso/saas/taskRecordSummary/list', query);
    commit('SET_PROJECT_SUMMARY', { projectSummary: data });
    commit('SET_PROJECT_SUMMARY_QUERY', { query: query });
  }
};
export const initProject = {
  root: false,
  handler: async ({ commit }, query) => {
    const {
      data: { data: detail }
    } = await request.post(
      '/rest/cso/saas/taskRecordAndSummaryDoc/queryCsoProjectNew',
      { projectId: query.projectId, type: query.type }
    );

    // 设置项目 详情
    commit('SET_PROJECT_DETAIL', {
      projectDetail: detail
    });
  }
};
